// Larger, name-only set of Font Awesome 6 Free Solid icons for the post-label icon picker.
// Unlike faIconList.js (video editor), these icons are only ever rendered live via the app's
// FA kit script (`fa-solid fa-<name>` CSS classes) — never baked into an exported video — so no
// SVG path/viewBox data is needed, which makes it practical to offer a much wider selection here.
export const LABEL_FA_ICONS = [
    { name: 'check', keywords: 'coche valide ok termine' },
    { name: 'xmark', keywords: 'croix annuler refuse' },
    { name: 'circle-check', keywords: 'valide approuve cercle' },
    { name: 'circle-xmark', keywords: 'refuse rejete cercle' },
    { name: 'circle-exclamation', keywords: 'attention important' },
    { name: 'triangle-exclamation', keywords: 'attention alerte danger' },
    { name: 'circle-info', keywords: 'info information' },
    { name: 'circle-question', keywords: 'question aide' },
    { name: 'ban', keywords: 'interdit bloque' },
    { name: 'flag', keywords: 'drapeau signal important' },
    { name: 'flag-checkered', keywords: 'fin objectif termine' },
    { name: 'bookmark', keywords: 'signet favori enregistrer' },
    { name: 'star', keywords: 'etoile favori important' },
    { name: 'star-half-stroke', keywords: 'demi etoile note' },
    { name: 'thumbtack', keywords: 'punaise epingler' },
    { name: 'bell', keywords: 'cloche notification alerte' },
    { name: 'bell-slash', keywords: 'muet notification off' },
    { name: 'hourglass', keywords: 'sablier attente' },
    { name: 'hourglass-half', keywords: 'en cours attente' },
    { name: 'stopwatch', keywords: 'chrono urgence rapide' },
    { name: 'clock', keywords: 'horloge temps planifie' },
    { name: 'calendar', keywords: 'calendrier date' },
    { name: 'calendar-check', keywords: 'planifie valide date' },
    { name: 'calendar-days', keywords: 'calendrier planning' },
    { name: 'calendar-plus', keywords: 'ajouter date' },
    { name: 'comment', keywords: 'commentaire message' },
    { name: 'comments', keywords: 'discussion echange' },
    { name: 'envelope', keywords: 'email mail message' },
    { name: 'envelope-open', keywords: 'email ouvert lu' },
    { name: 'paper-plane', keywords: 'envoyer message' },
    { name: 'phone', keywords: 'telephone appel' },
    { name: 'phone-volume', keywords: 'telephone sonnerie' },
    { name: 'at', keywords: 'arobase mention' },
    { name: 'hashtag', keywords: 'hashtag diese' },
    { name: 'bullhorn', keywords: 'annonce marketing publicite' },
    { name: 'share', keywords: 'partager' },
    { name: 'share-nodes', keywords: 'partager reseau' },
    { name: 'rss', keywords: 'flux abonnement' },
    { name: 'inbox', keywords: 'boite reception' },
    { name: 'briefcase', keywords: 'travail business pro' },
    { name: 'chart-line', keywords: 'graphique statistiques croissance' },
    { name: 'chart-bar', keywords: 'graphique statistiques' },
    { name: 'chart-pie', keywords: 'graphique repartition' },
    { name: 'chart-simple', keywords: 'graphique data' },
    { name: 'money-bill', keywords: 'argent budget' },
    { name: 'money-bill-wave', keywords: 'argent paiement' },
    { name: 'coins', keywords: 'argent monnaie' },
    { name: 'sack-dollar', keywords: 'argent revenu' },
    { name: 'credit-card', keywords: 'paiement carte' },
    { name: 'handshake', keywords: 'partenariat accord collaboration' },
    { name: 'building', keywords: 'entreprise bureau' },
    { name: 'building-columns', keywords: 'banque institution' },
    { name: 'store', keywords: 'boutique magasin' },
    { name: 'cart-shopping', keywords: 'achat panier vente' },
    { name: 'tag', keywords: 'etiquette prix' },
    { name: 'tags', keywords: 'etiquettes categories' },
    { name: 'receipt', keywords: 'facture recu' },
    { name: 'wallet', keywords: 'portefeuille budget' },
    { name: 'user', keywords: 'utilisateur personne' },
    { name: 'users', keywords: 'equipe groupe' },
    { name: 'user-plus', keywords: 'ajouter utilisateur' },
    { name: 'user-check', keywords: 'utilisateur valide' },
    { name: 'user-tie', keywords: 'client professionnel' },
    { name: 'user-group', keywords: 'equipe communaute' },
    { name: 'crown', keywords: 'premium vip roi' },
    { name: 'id-card', keywords: 'identite carte' },
    { name: 'address-book', keywords: 'contacts carnet' },
    { name: 'image', keywords: 'photo visuel' },
    { name: 'images', keywords: 'photos galerie carrousel' },
    { name: 'video', keywords: 'video film' },
    { name: 'film', keywords: 'film video montage' },
    { name: 'music', keywords: 'musique son audio' },
    { name: 'headphones', keywords: 'audio ecoute' },
    { name: 'microphone', keywords: 'micro enregistrement' },
    { name: 'camera', keywords: 'photo appareil' },
    { name: 'camera-retro', keywords: 'photo vintage' },
    { name: 'palette', keywords: 'design couleur creatif' },
    { name: 'paintbrush', keywords: 'design creation' },
    { name: 'pen', keywords: 'ecrire redaction' },
    { name: 'pen-nib', keywords: 'ecriture signature' },
    { name: 'pencil', keywords: 'modifier editer' },
    { name: 'highlighter', keywords: 'surligner important' },
    { name: 'book', keywords: 'livre lecture' },
    { name: 'book-open', keywords: 'lecture guide' },
    { name: 'newspaper', keywords: 'actualite presse news' },
    { name: 'print', keywords: 'imprimer' },
    { name: 'laptop', keywords: 'ordinateur informatique' },
    { name: 'mobile', keywords: 'mobile telephone' },
    { name: 'mobile-screen', keywords: 'mobile application' },
    { name: 'desktop', keywords: 'ordinateur bureau' },
    { name: 'wifi', keywords: 'connexion internet' },
    { name: 'cloud', keywords: 'nuage stockage' },
    { name: 'cloud-arrow-up', keywords: 'upload envoi' },
    { name: 'cloud-arrow-down', keywords: 'telecharger' },
    { name: 'database', keywords: 'donnees base' },
    { name: 'server', keywords: 'serveur technique' },
    { name: 'code', keywords: 'developpement technique' },
    { name: 'terminal', keywords: 'developpement code' },
    { name: 'robot', keywords: 'automatisation bot ia' },
    { name: 'gear', keywords: 'parametre reglage' },
    { name: 'gears', keywords: 'parametres processus' },
    { name: 'wrench', keywords: 'outil reparation' },
    { name: 'screwdriver-wrench', keywords: 'outils maintenance' },
    { name: 'bug', keywords: 'probleme erreur bug' },
    { name: 'shield', keywords: 'securite protection' },
    { name: 'shield-halved', keywords: 'securite defense' },
    { name: 'lock', keywords: 'verrouille prive' },
    { name: 'unlock', keywords: 'deverrouille public' },
    { name: 'key', keywords: 'cle acces important' },
    { name: 'sun', keywords: 'soleil ete' },
    { name: 'moon', keywords: 'lune nuit' },
    { name: 'cloud-sun', keywords: 'meteo nuage soleil' },
    { name: 'cloud-rain', keywords: 'pluie meteo' },
    { name: 'snowflake', keywords: 'neige hiver' },
    { name: 'fire', keywords: 'populaire tendance urgent' },
    { name: 'bolt', keywords: 'eclair energie rapide' },
    { name: 'leaf', keywords: 'nature ecologie' },
    { name: 'tree', keywords: 'nature arbre' },
    { name: 'seedling', keywords: 'nouveau debut croissance' },
    { name: 'droplet', keywords: 'eau goutte' },
    { name: 'wind', keywords: 'vent meteo' },
    { name: 'plane', keywords: 'avion voyage' },
    { name: 'car', keywords: 'voiture transport' },
    { name: 'truck', keywords: 'camion livraison' },
    { name: 'ship', keywords: 'bateau transport' },
    { name: 'train', keywords: 'train transport' },
    { name: 'bicycle', keywords: 'velo sport' },
    { name: 'location-dot', keywords: 'lieu localisation pin' },
    { name: 'map', keywords: 'carte plan' },
    { name: 'map-pin', keywords: 'localisation lieu' },
    { name: 'globe', keywords: 'monde international' },
    { name: 'compass', keywords: 'direction navigation' },
    { name: 'mountain', keywords: 'montagne nature' },
    { name: 'house', keywords: 'maison accueil' },
    { name: 'bed', keywords: 'hebergement hotel' },
    { name: 'mug-hot', keywords: 'boisson chaude cafe' },
    { name: 'mug-saucer', keywords: 'cafe boisson' },
    { name: 'pizza-slice', keywords: 'nourriture pizza' },
    { name: 'burger', keywords: 'nourriture fast food' },
    { name: 'apple-whole', keywords: 'fruit sante' },
    { name: 'carrot', keywords: 'legume sante' },
    { name: 'utensils', keywords: 'restaurant repas' },
    { name: 'wine-glass', keywords: 'boisson alcool' },
    { name: 'futbol', keywords: 'football sport' },
    { name: 'basketball', keywords: 'basketball sport' },
    { name: 'dumbbell', keywords: 'sport fitness musculation' },
    { name: 'trophy', keywords: 'victoire gagnant succes' },
    { name: 'medal', keywords: 'recompense succes' },
    { name: 'gamepad', keywords: 'jeu gaming' },
    { name: 'chess', keywords: 'strategie jeu' },
    { name: 'dice', keywords: 'jeu chance' },
    { name: 'face-smile', keywords: 'sourire content heureux' },
    { name: 'face-frown', keywords: 'triste mecontent' },
    { name: 'face-laugh', keywords: 'rire drole humour' },
    { name: 'heart', keywords: 'coeur amour like' },
    { name: 'heart-crack', keywords: 'coeur brise deception' },
    { name: 'thumbs-up', keywords: 'pouce like bien' },
    { name: 'thumbs-down', keywords: 'pouce dislike mauvais' },
    { name: 'hand', keywords: 'main stop' },
    { name: 'peace', keywords: 'paix calme' },
    { name: 'infinity', keywords: 'infini illimite' },
    { name: 'plus', keywords: 'ajouter plus' },
    { name: 'minus', keywords: 'moins retirer' },
    { name: 'arrow-up', keywords: 'fleche haut hausse' },
    { name: 'arrow-down', keywords: 'fleche bas baisse' },
    { name: 'arrow-right', keywords: 'fleche droite suivant' },
    { name: 'arrow-left', keywords: 'fleche gauche precedent' },
    { name: 'arrows-rotate', keywords: 'actualiser rafraichir' },
    { name: 'rotate', keywords: 'pivoter recommencer' },
    { name: 'magnifying-glass', keywords: 'recherche loupe' },
    { name: 'filter', keywords: 'filtrer trier' },
    { name: 'list', keywords: 'liste' },
    { name: 'list-check', keywords: 'checklist tache' },
    { name: 'clipboard', keywords: 'presse papier notes' },
    { name: 'clipboard-check', keywords: 'valide tache faite' },
    { name: 'folder', keywords: 'dossier fichiers' },
    { name: 'folder-open', keywords: 'dossier ouvert' },
    { name: 'box', keywords: 'boite produit colis' },
    { name: 'boxes-stacked', keywords: 'stock inventaire' },
    { name: 'truck-fast', keywords: 'livraison rapide express' },
    { name: 'rocket', keywords: 'lancement demarrage rapide' },
    { name: 'lightbulb', keywords: 'idee inspiration' },
    { name: 'puzzle-piece', keywords: 'solution integration' },
    { name: 'gift', keywords: 'cadeau offre surprise' },
    { name: 'cake-candles', keywords: 'anniversaire fete' },
    { name: 'umbrella', keywords: 'protection pluie' },
    { name: 'anchor', keywords: 'stable ancre' },
    { name: 'flask', keywords: 'test experimentation' },
    { name: 'microscope', keywords: 'analyse recherche' },
    { name: 'graduation-cap', keywords: 'formation education' },
    { name: 'school', keywords: 'education formation' },
]

export const LABEL_FA_ICONS_BY_NAME = LABEL_FA_ICONS.reduce((map, icon) => {
    map[icon.name] = icon
    return map
}, {})
